import {
    UNASSIGN_DRIVERS_REQUEST,
    UNASSIGN_DRIVERS_RESULT,
    UNASSIGN_DRIVERS_OPEN_MODAL,
    UNASSIGN_DRIVERS_CLOSE_MODAL,
    UNASSIGN_DRIVERS_GET_KEYFOB_REQUEST,
    UNASSIGN_DRIVERS_GET_KEYFOB_RESULT,
    UNASSIGN_DRIVERS_SET_DEVICE,
    CLEAR_REDUX,
} from "Redux/actionTypes";

const INIT_STATE = {
    loading: false,
    openModal: false,
    result: null,
    error: null,
    keyFob: null,
    keyFobs: [],
    selectedKeyFobs: [],
};

export default (state = INIT_STATE, action) => {

    switch (action.type) {
        case UNASSIGN_DRIVERS_REQUEST:
            return { ...state, loading: true }

        case UNASSIGN_DRIVERS_RESULT:
            return { ...state, loading: false, result: action.payload }

        case UNASSIGN_DRIVERS_OPEN_MODAL:
            return { ...state, openModal: true, selectedKeyFobs: action.payload }

        case UNASSIGN_DRIVERS_CLOSE_MODAL:
            return { ...state, openModal: false }

        case UNASSIGN_DRIVERS_GET_KEYFOB_REQUEST:
            return { ...state, loading: true }

        case UNASSIGN_DRIVERS_GET_KEYFOB_RESULT:
            return { ...state, loading: false, keyFob: action.payload }

        case UNASSIGN_DRIVERS_SET_DEVICE:
            return { ...state, keyFobs: action.payload }


        case CLEAR_REDUX:
            return ["", "UNASSIGN_DRIVERS"].includes(action.payload.option)
                ? action.payload.parameters ? { ...state, ...action.payload.parameters } : { ...INIT_STATE }
                : { ...state }
        default:
            return state;
    }
};